var map = {
	"./A.GANESH.jpg": 58375,
	"./A.SARAVANAN.jpg": 66078,
	"./Dr.A.MOHANKUMAR.JPG": 2493,
	"./Dr.A.TAMILVANAN.jpg": 20818,
	"./Dr.B.S.HARI.jpg": 95847,
	"./Dr.M.BHUVANESH KUMAR.jpg": 66685,
	"./Dr.M.MAHESH.jpg": 35189,
	"./Dr.M.SAMBATHKUMAR.jpg": 8289,
	"./Dr.P.SELVAKUMAR.jpg": 43057,
	"./Dr.R.GUKENDRAN.jpg": 74505,
	"./Dr.R.NAVEEN KUMAR.jpeg": 89500,
	"./Dr.R.RAJASEKAR.jpg": 43758,
	"./Dr.T.P.SATHISHKUMAR.JPG": 37839,
	"./K.V.SATHEESH KUMAR.jpg": 42768,
	"./M.DHARMARAJ.jpeg": 51760,
	"./R.KAMALAKANNAN.jpg": 82658,
	"./R.KARTHIKEYAN.jpeg": 64984,
	"./dr_v_balusamy.jpg": 85918,
	"./raja.jpeg": 4605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26918;